export const NestedFormRenumber = (controller) => {
  Object.assign(controller, {
    renumber: (element, index) => {
      const id = element.getAttribute("id");
      if (id) {
        const newId = id.replace(/_\d+_/, `_${index}_`);
        element.setAttribute("id", newId);
      }

      const name = element.getAttribute("name");
      if (name) {
        const newName = name.replace(/\[\d+\]/, `[${index}]`);
        element.setAttribute("name", newName);
      }
    },
  });
};
